import React from 'react';
import { useAppSelector} from "../../creator-presets/DAL/store";
import HearOnYourTrack from "./hear-on-your-track";
import CreatorDetailsMobile from "./creator-details-mobile";
import {ModeratorEntityTypeEnum} from "../../common/common-enum";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";


const PresetDetailsMobile = () => {

    const mainPreset = useAppSelector((store) => store.mainPreset);

    return (
        <div className="w-full">
            <div className="w-full flex mb-4 items-center justify-between">
                <p className="text-3xl font-bold pb-0">{mainPreset.presetName}</p>
                <span className="text-sm min-w-fit">
                    <a className="text-black"
                       onClick={(evt) => {
                           sendGAEvent('Click', "Report an issue Chain: " + mainPreset.presetName);
                       }}
                       href={"/studioverse/report-an-issue/"+ModeratorEntityTypeEnum.Preset+"/"+mainPreset.presetGUID}>Report an issue</a>
                </span>

            </div>
            <CreatorDetailsMobile />


            <div className="w-full">
                <div className="w-full mt-4">
                    <HearOnYourTrack />
                </div>
            </div>

        </div>

    )
};

export default PresetDetailsMobile;